"use strict";

const $form = $("#babolat-cup-applicant-form");
const $babolatCupBlock = $(".js-babolat-cup-form-container");
const $applicants = $babolatCupBlock.find(".js-applicants");
const isBabolatCupEnabled = $form.length > 0;
const $applicantTemp = $(".js-new-applicant-template");
const $formErrorBlock = $(".js-form-validation-error");
const $participantErrorBlock = $(".js-participant-validation-error");
const processInclude = require("../util");
const clearInputField = require("../components/clearInputField");
const Lightpick = require("../components/lightpick");
const AGE_VARIATION_ATTRIBUTE_ID = "MISCELLANEOUS_SIZE";
const $body = $("body");
const base = require("./base");
const applicantObjTemp = {
    participantFirstName: "",
    participantLastName: "",
    dateOfBirth: "",
    licenceNumber: "",
    club: "",
    age: ""
};
const ENTER_KEY = 13;
const SPACE_KEY = 32;
const isMinimumBirthDayDisabled = $form.data("disable-minimum-age-restriction");
const birthdateConfig = getBirthdateInputConfig();

// babolatcup birthdays are restricted to a certain range
function getBirthdateInputConfig() {
    const currentYear = new Date().getFullYear();
    const maxDate = !isMinimumBirthDayDisabled ? new Date(new Date(`1/1/${currentYear - 9}`) - 86400000) : null;
    const minDate = new Date(`1/1/${currentYear - 14}`);

    return {
        field: null,
        minDate: minDate,
        maxDate: maxDate
    };
}


/**
* Adds a new applicant template to the form, updating the index and IDs for each input and label.
* This function dynamically appends a new applicant block to the existing list of applicants,
* ensuring that each input and label has a unique ID based on the current count of applicants.
* It also initializes a date picker for the date of birth field and sets up an event listener
* for handling birthdate input.
*/
function addApplicantTemplate() {
    let $newApplicantTemp = $($applicantTemp.html());
    let currentCount = $applicants.find(".js-applicant-block").length;

    $newApplicantTemp.attr("data-index", currentCount);
    $newApplicantTemp.find("input").each(function () {
        let $this = $(this);
        let newId = $this.attr("id").replace("$", currentCount);
        $this.attr("id", newId);
    });
    $newApplicantTemp.find("label").each(function () {
        let $this = $(this);
        let newId = $this.attr("for").replace("$", currentCount);
        $this.attr("for", newId);
    });

    $applicants.append($newApplicantTemp);

    $(".clear-input-button").remove();
    clearInputField();

    $(`#dateOfBirth${currentCount}`).each(function (i, el) {
        const config = birthdateConfig;

        config.field = el;
        new Lightpick(config);

        el.addEventListener("keyup", getBirthdate);
    });
}

/**
* Removes the applicant template block from the DOM.
* This function is triggered by an event on an element within the applicant block.
* It identifies the closest parent element with the class 'js-applicant-block' and removes it.
*/
function removeApplicantTemplate() {
    let $this = $(this);
    let $block = $this.closest(".js-applicant-block");

    $block.remove();
}

/**
* Handles errors for the Babolat Cup form by highlighting the applicant block with errors
* and scrolling to its position. Additionally, it displays error blocks for the form and participants.
*
* @param {Object} data - The data object containing error information.
* @param {number} data.applicantIndex - The index of the applicant block that contains errors.
*/
function handleBabolatCupFormErrors(data) {
    let $blockWithErrors = $($applicants.find(".js-applicant-block").get(data.applicantIndex));

    $blockWithErrors.addClass("invalid");
    $blockWithErrors.find("input").trigger("focus");

    $("html, body").animate({
        scrollTop: $blockWithErrors.offset().top - 150
    }, "slow");

    $formErrorBlock.removeClass("d-none");
    $participantErrorBlock.toggleClass("d-none", data.hasDuplicates ? !data.hasDuplicates : true);
}

/**
* Clears error indicators from the applicant blocks and hides error messages.
* 
* This function removes the 'invalid' class from all elements with the class 
* 'js-applicant-block' within the $applicants context. It also hides the 
* form and participant error blocks by adding the 'd-none' class to them.
*/
function clearErrors() {
    $applicants.find(".js-applicant-block").removeClass("invalid");
    $formErrorBlock.addClass("d-none");
    $participantErrorBlock.addClass("d-none");
}

/**
* Submits the applicants form for the Babolat Cup, handling CSRF token validation,
* form validation, and AJAX submission. It checks if the necessary conditions are
* accepted before proceeding with the form submission.
*
* The function performs the following steps:
* 1. Retrieves the CSRF token from the form.
* 2. Clears any existing error messages.
* 3. Validates that the image rights and personal information allowance checkboxes are checked.
* 4. If validation fails, disables the submit button and displays an error block.
* 5. Initiates an AJAX POST request to submit the form data if validation passes.
* 6. Handles the server response, updating the UI based on success or failure.
* 7. On success, triggers events for post-cart addition and updates the mini cart.
* 8. Resets the experience and scrolls to the top of the page after a delay.
*
* @returns {void}
*/
function submitApplicantsForm() {
    const csrf_token = $("input[name='csrf_token']").val();
    clearErrors();

    // check if conditions are checked
    const imageRightsChecked = $("#babolat-cup-personal-image-rights").prop("checked");
    const personalInfoChecked = $("#babolat-cup-personal-info-allowence").prop("checked");
    const $customDataPlatformCheckInput = $("#babolat-cup-personal-data-platform-allowence");
    const personalDataPlatformChecked = $customDataPlatformCheckInput.length ? $customDataPlatformCheckInput.prop("checked") : true;

    if (!imageRightsChecked || !personalInfoChecked || !personalDataPlatformChecked) {
        $(".js-submit-applicants").prop("disabled", true);
        $formErrorBlock.removeClass("d-none");

        return;
    }

    $.spinner().start();

    $.ajax({
        type: "POST",
        url: $form.attr("action") + "?csrf_token=" + csrf_token,
        data: {
            data: JSON.stringify({
                data: getApplicantsJSON(),
            })
        },
        success: function success(data) {
            $.spinner().stop();

            if (!data.success) {
                handleBabolatCupFormErrors(data);
            } else {
                base.methods.handlePostCartAdd(data);
                $body.trigger("product:afterAddToCart", data);
                base.miniCartReportingUrl(data.reportingURL);

                setTimeout(function () {
                    resetExperience();
                    $body.trigger("minicart:close");

                    $("html, body").animate({
                        scrollTop: 0
                    }, "slow");
                }, 6000);
            }
        },
        error: function error() {
            $.spinner().stop();
        }
    });
}

/**
* Resets the Babolat Cup form experience to its default state.
*
* This function resets various form elements within the Babolat Cup form,
* including dropdown selections and checkbox states, to their initial values.
* It also triggers change events on these elements to ensure any associated
* event handlers are executed.
*
* The function specifically performs the following actions:
* - Resets the age variation dropdown to its default option.
* - Unchecks and triggers change events on the personal image rights and
*   personal information allowance checkboxes.
* - Calls the `resetApplicantsForm` function to reset the applicants' form.
*/
function resetExperience() {
    let $ageVariationBlock = $(`[data-attr=${AGE_VARIATION_ATTRIBUTE_ID}]`);
    let optionVal = $ageVariationBlock.find("option").val();

    $ageVariationBlock.find("select").val(optionVal).trigger("change");
    $("#babolat-cup-personal-image-rights").prop("checked", false).trigger("change");
    $("#babolat-cup-personal-info-allowence").prop("checked", false).trigger("change");
    $("#babolat-cup-personal-data-platform-allowence").prop("checked", false).trigger("change");

    resetApplicantsForm();
}

/**
* Constructs a JSON array of applicant objects from the DOM elements.
* Iterates over each applicant block in the DOM, extracting values for each
* attribute defined in the `applicantObjTemp` and compiles them into an object.
* Each applicant object is then appended to the `applicants` array.
*
* @returns {Array<Object>} An array of applicant objects, each containing
*                          key-value pairs for applicant attributes and an
*                          `applicantIndex` indicating the order of the applicant.
*/
function getApplicantsJSON() {
    let applicants = [];
    let applicantAttributes = Object.keys(applicantObjTemp);
    let $applicantsBlock = $(".js-applicants").find(".js-applicant-block");

    $applicantsBlock.each((i, el) => {
        let $el = $(el);
        let applicantObj = {};

        applicantAttributes.forEach((attr) => {
            applicantObj[attr] = $el.find(`[name=${attr}]`).val();
            if (attr === "age") {
                let productID = $el.find('[name="age"] option:selected').data('pid');
                applicantObj.pid = productID;
            }
        });

        applicantObj["applicantIndex"] = i;
        applicants.push(applicantObj);
    });

    return applicants;
}

/**
* Handles changes in product variation and updates the form and UI elements accordingly.
*
* This function is triggered on a variation change event, and it updates the product form
* and UI elements based on the availability and orderability of the selected product variation.
* It also constructs the tournament age select options and handles the display of stock messages.
*
* @param {Event} event - The event object associated with the variation change.
* @param {Object} data - The data object containing the response from the server.
* @param {Object} data.response - The response object from the server.
* @param {Object} data.response.product - The product object containing details of the selected variation.
* @param {boolean} data.response.product.available - Indicates if the product is available.
* @param {boolean} data.response.product.readyToOrder - Indicates if the product is ready to be ordered.
* @param {boolean} data.response.product.orderable - Indicates if the product can be ordered.
* @param {string} data.response.product.id - The product ID of the selected variation.
* @param {Array} data.response.product.variationAttributes - Array of variation attributes for the product.
* @param {string} data.response.product.variationAttributes[].id - The ID of the variation attribute.
* @param {Array} data.response.product.variationAttributes[].values - Array of values for the variation attribute.
* @param {string} data.response.product.variationAttributes[].values[].displayValue - The display value of the variation.
* @param {boolean} data.response.product.variationAttributes[].values[].selected - Indicates if the variation is selected.
* @param {boolean} data.response.product.variationAttributes[].values[].selectable - Indicates if the variation is selectable.
*/
function handleOnVariationChange(event, data) {
    const product = data.response && data.response.product;

    $babolatCupBlock.addClass("d-none");
    resetApplicantsForm();

    if (!product) {
        return;
    }

    const $formInitButton = event ? $(event.currentTarget) : $(".js-babolat-cup-init-btn");

    $formInitButton.prop("disabled", !(product.available && product.readyToOrder && product.orderable));
    $form.attr("data-pid", product.id);

    // construct tournament age select options
    let variationAttributes = product.variationAttributes.find((attr) => attr.id === AGE_VARIATION_ATTRIBUTE_ID).values;
    let optionsHTML = "";

    variationAttributes.forEach((attr) => {
        optionsHTML += `<option value="${attr.displayValue}" data-pid=${attr.variantID} ${attr.selected ? "selected" : ""} ${attr.selectable ? "" : "disabled"}>${attr.displayValue}</option>`;
    });

    $form.find("[name='age']").html(optionsHTML);
    $applicantTemp.find("[name='age']").html(optionsHTML);

    // handle out of stock message
    let ctaDisabled = product.isCTADisabled || !product.readyToOrder || !product.available;
    let tournamentOver = !product.available;
    $(".js-babolat-cup-init-btn").prop("disabled", ctaDisabled).toggleClass("over", tournamentOver);
}

/**
* Resets the applicants form by removing additional applicant blocks and clearing input values.
* This function targets the elements within the applicants section of the form, ensuring that
* only the first applicant block remains and all input fields are reset to their default state.
* Additionally, it clears any existing error messages from the form.
*/
function resetApplicantsForm() {
    $applicants.find(".js-applicant-block").slice(1).remove();
    $applicants.find("input").val("");

    clearErrors();
}

/**
* Initializes event listeners for the Babolat Cup form interactions.
* 
* This function sets up various event handlers on the page to manage user interactions
* with the Babolat Cup form. It handles adding and removing applicants, submitting the form,
* toggling form visibility, and updating form state based on user input.
* 
* Event Listeners:
* - Click on ".js-add-another-applicant": Adds a new applicant template to the form.
* - Click on ".js-remove-applicant": Removes an applicant template from the form.
* - Click on ".js-submit-applicants": Submits the applicants form.
* - Click on ".js-babolat-cup-init-btn": Toggles the visibility of the form.
* - Submit on the form: Prevents the default form submission behavior.
* - Custom event "product:updateBabolatCup" on ".js-babolat-cup-init-btn": Handles changes in product variations.
* - Change on "#babolat-cup-personal-image-rights" and "#babolat-cup-personal-info-allowence": 
*   Enables the submit button if both checkboxes are checked.
* - Click on ".js-dissmiss-error": Dismisses error messages by hiding the error block.
*/
function initEvents() {
    $body.on("click", ".js-add-another-applicant", addApplicantTemplate);
    $body.on("click", ".js-remove-applicant", removeApplicantTemplate);
    $body.on("click", ".js-submit-applicants", submitApplicantsForm);
    $body.on("click", ".js-babolat-cup-init-btn", toggleFormVisibility);
    $form.on("submit", function (e) {
        e.preventDefault();
    });

    $(".js-babolat-cup-init-btn").on("product:updateBabolatCup", handleOnVariationChange);

    $body.on("change", "#babolat-cup-personal-image-rights, #babolat-cup-personal-info-allowence, #babolat-cup-personal-data-platform-allowence", function () {
        const imageRightsChecked = $("#babolat-cup-personal-image-rights").prop("checked");
        const personalInfoChecked = $("#babolat-cup-personal-info-allowence").prop("checked");
        const $customDataPlatformCheckInput = $("#babolat-cup-personal-data-platform-allowence");
        const personalDataPlatformChecked = $customDataPlatformCheckInput.length ? $customDataPlatformCheckInput.prop("checked") : true;

        if (imageRightsChecked && personalInfoChecked && personalDataPlatformChecked) {
            $(".js-submit-applicants").prop("disabled", false);
        }
    });

    $body.on("click", ".js-dissmiss-error", function () {
        $(this).closest(".js-babolatcup-error-block").addClass("d-none");
    });
}

/**
* Toggles the visibility of the Babolat Cup form by removing the 'd-none' class
* from the associated HTML block and smoothly scrolls the page to the form.
* 
* This function ensures that the Babolat Cup form is visible to the user and
* provides a smooth scrolling experience to bring the form into view.
* 
* @function toggleFormVisibility
* @returns {void}
*/
function toggleFormVisibility() {
    $babolatCupBlock.removeClass("d-none");

    $("html, body").animate({
        scrollTop: $babolatCupBlock.offset().top - 150
    }, "slow");

    setTimeout(function() {
        $babolatCupBlock.find(".babolat-cup-applicants-list input").first().trigger("focus");
    }, 400);
}

/**
* Initializes the Lightpick date picker for each birth date input field within the applicants section.
* This function selects all elements with the name attribute 'dateOfBirth' and applies the Lightpick
* date picker to each of them. Additionally, it adds an event listener to handle the 'keyup' event
* for each input field, triggering the getBirthdate function.
*/
function initLightPickForBirthDate() {
    $applicants.find("[name='dateOfBirth']").each(function (i, el) {
        const config = birthdateConfig;

        config.field = el;
        new Lightpick(config);

        el.addEventListener("keyup", getBirthdate);
    });
}

/**
* Formats the birthdate input field based on the current site locale.
* 
* This function modifies the value of the birthdate input field to ensure
* it follows the correct date format based on whether the current site is
* BabolatJP or not. For BabolatJP, the format is YYYY/MM/DD, and for other
* sites, it is MM/DD/YYYY. Non-numeric and non-slash characters are removed
* from the input.
* 
* @param {Event} e - The event object triggered by the input field change.
*/
function getBirthdate(e) {
    const birthdateField = e.target;
    const isSiteJP = $(".isSiteJP").val();
    const config = birthdateConfig; // Use the existing birthdateConfig for min and max dates

    // Parse the input date
    let inputDate;
    // Trigger only if current site is BabolatJP
    if (isSiteJP === "true") {
        birthdateField.value = birthdateField.value.replace(/^(\d\d\d\d)(\d)$/g, "$1/$2").replace(/^(\d\d\d\d\/\d\d)(\d+)$/g, "$1/$2").replace(/[^\d\/]/g, ""); // eslint-disable-line
        inputDate = new Date(birthdateField.value);
    // For any other site that is not JP enter else
    } else {
        birthdateField.value = birthdateField.value.replace(/^(\d\d)(\d)$/g, "$1/$2").replace(/^(\d\d\/\d\d)(\d+)$/g, "$1/$2").replace(/[^\d\/]/g, ""); // eslint-disable-line
        const parts = birthdateField.value.split("/");
        inputDate = new Date(parts[2], parts[0] - 1, parts[1]); // Assuming MM/DD/YYYY format
    }

    // Check if the input date is outside the allowed range
    if (birthdateField.value.length > 9 && inputDate < config.minDate) {
        birthdateField.value = formatDate(config.minDate, isSiteJP);
    } else if (birthdateField.value.length > 9 && inputDate > config.maxDate) {
        birthdateField.value = formatDate(config.maxDate, isSiteJP);
    }
}

// Helper function to format the date based on the site locale
function formatDate(date, isSiteJP) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    if (isSiteJP === "true") {
        return `${year}/${month}/${day}`; // YYYY/MM/DD format for JP
    } else {
        return `${month}/${day}/${year}`; // MM/DD/YYYY format for other sites
    }
}

// if product id is variation product, fill initial ages dropdown on load
function initInitialAges() {
    const $selectedOption = $(`.select-${AGE_VARIATION_ATTRIBUTE_ID} option:selected`);
    const attrValue = $selectedOption.data("attr-value");

    if ($selectedOption.length === 0 || !attrValue) {
        return;
    }

    const url = $selectedOption.val();
    const urlObj = new URL(url);
    const searchParams = new URLSearchParams(urlObj.search);

    searchParams.forEach((value, key) => {
        if (key.indexOf(AGE_VARIATION_ATTRIBUTE_ID) > -1) {
            searchParams.set(key, attrValue);
        }
    });
    urlObj.search = searchParams.toString();

    $.ajax({
        url: urlObj.toString(),
        method: "GET",
        success: function (data) {
            handleOnVariationChange(null, {response: data});
        }
    });
}

/**
* Initializes keyboard accessibility for custom checkbox elements within the form.
* This function listens for keydown events on elements with the class 'custom-checkbox'
* and toggles the checked state of the associated input when the Enter or Space key is pressed.
*/
function initFormAccessibility() {
    $body.on("keydown", ".custom-checkbox", function (e) {
        if (e.keyCode === ENTER_KEY || e.keyCode === SPACE_KEY) {
            e.preventDefault();

            $(this).find("input").prop("checked", function (i, val) {
                return !val;
            }).trigger("change");
        }
    });
}

module.exports = {
    /**
    * Initializes the Babolat Cup form functionality if the feature is enabled.
    * This function sets up necessary event listeners, processes additional components,
    * and initializes the date picker for the birth date field.
    * 
    * @function
    * @returns {void}
    */
    init: function () {
        if (!isBabolatCupEnabled) {
            return;
        }

        initEvents();
        processInclude(require("../components/showLess"));
        initLightPickForBirthDate();
        initInitialAges();
        initFormAccessibility();
    }
};
